/*
 * inselvolt Kompatibilitätsberater — Deep-Link (reine Logik).
 *
 * Herausgelöst aus app/berater-ui.js (E6, 2026-08-25): Serialisierung und
 * Auflösung des Adress-Hashes als reine Funktionen, damit sie ohne DOM
 * testbar sind. Das window-I/O (location.hash lesen, history.replaceState)
 * bleibt als Zweizeiler in der UI-Schale.
 *
 * Format: #<aufgabe>&wr=<wr_varianten_id>&sp=<speicher_familie>~<groesse>
 * Beispiel: #erweitern&sp=byd-hvs-plus~7.7&wr=g3-10
 *
 * Unbekannte Werte werden VERWORFEN, nie geraten: Ein Hash aus einem alten
 * Lesezeichen darf nur setzen, was die Datenbasis heute noch kennt — ein
 * kaputter Hash liefert ein leeres Ergebnis und blockiert nie die Seite.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.IVBeraterDeeplink = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  /* Zustand → Hash-Text (mit führendem '#'). */
  function hashAusZustand(zustand) {
    var teile = [zustand.aufgabe];
    if (zustand.wrVariante) teile.push('wr=' + zustand.wrVariante);
    if (zustand.spFamilie && zustand.spGroesse) teile.push('sp=' + zustand.spFamilie + '~' + zustand.spGroesse);
    return '#' + teile.join('&');
  }

  /*
   * Hash-Text → validierter Teil-Zustand. Liefert NUR die Schlüssel, die sich
   * gegen die Datenbasis auflösen ließen; der Aufrufer legt sie über seinen
   * Zustand. aufgabenIds = die gültigen Aufgaben-Kennungen der UI.
   */
  function zustandAusHash(hash, daten, aufgabenIds) {
    var ergebnis = {};
    var roh = String(hash || '').replace(/^#/, '');
    if (!roh || !daten) return ergebnis;

    var teile = roh.split('&');
    var aufgabe = teile.shift();
    if ((aufgabenIds || []).indexOf(aufgabe) !== -1) ergebnis.aufgabe = aufgabe;

    teile.forEach(function (t) {
      if (t.indexOf('wr=') === 0) {
        var v = t.slice(3);
        (daten.wechselrichter || []).forEach(function (f) {
          (f.varianten || []).forEach(function (va) {
            if (va.id === v) {
              ergebnis.wrVariante = v;
              ergebnis.wrFamilie = f.id;
              ergebnis.wrHersteller = f.hersteller;
            }
          });
        });
      } else if (t.indexOf('sp=') === 0) {
        var paar = t.slice(3).split('~');
        var fam = null;
        (daten.speicher || []).forEach(function (f) { if (f.id === paar[0]) fam = f; });
        if (fam && (fam.groessen || []).some(function (g) { return g.groesse === paar[1]; })) {
          ergebnis.spFamilie = paar[0];
          ergebnis.spGroesse = paar[1];
          ergebnis.spHersteller = fam.hersteller;
        }
      }
    });
    return ergebnis;
  }

  return {
    hashAusZustand: hashAusZustand,
    zustandAusHash: zustandAusHash,
  };
});
